var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images
    ? _c(
        "div",
        { staticClass: "images-gallery-container" },
        [
          _c(
            "div",
            { ref: "images_gallery", staticClass: "images-gallery" },
            [
              _c(
                "swiper",
                {
                  ref: "swiperGallery",
                  staticClass: "swiper",
                  attrs: { options: _vm.swiper_option },
                  on: { slideChangeTransitionEnd: _vm.slideChanged }
                },
                [
                  _vm._l(_vm.images, function(image, index) {
                    return _c("swiper-slide", { key: index }, [
                      _vm.showIcons
                        ? _c(
                            "div",
                            {
                              style: {
                                width: _vm.local_images[image.id].width + "px",
                                height:
                                  _vm.local_images[image.id].height + "px",
                                margin: "auto"
                              }
                            },
                            [
                              _c("img", {
                                style: {
                                  width:
                                    _vm.local_images[image.id].width + "px",
                                  height:
                                    _vm.local_images[image.id].height + "px"
                                },
                                attrs: { src: image.url.gallery }
                              }),
                              _vm._v(" "),
                              _vm.hasIcons && _vm.active == index
                                ? _c("floor-plan-icons", {
                                    attrs: {
                                      "floor-plan": _vm.local_images[image.id]
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _c("img", {
                            staticClass: "img-gallery swiper-lazy",
                            attrs: { "data-src": image.url.gallery }
                          }),
                      _vm._v(" "),
                      !_vm.showIcons
                        ? _c("div", { staticClass: "swiper-lazy-preloader" })
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-button-prev",
                    attrs: { slot: "button-prev" },
                    slot: "button-prev"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-button-next",
                    attrs: { slot: "button-next" },
                    slot: "button-next"
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.thumb
            ? _c(
                "div",
                {
                  class: _vm.show_thumb
                    ? "thumb_close_open"
                    : "thumb_close_closed"
                },
                [
                  _c("div", { staticClass: "thumb_close" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.active + 1) +
                        " / " +
                        _vm._s(_vm.images.length) +
                        "\n            " +
                        _vm._s(
                          _vm.show_thumb
                            ? _vm.lang.media.thumb_close
                            : _vm.lang.media.thumb_open
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.show_thumb
                    ? _c(
                        "div",
                        { staticClass: "images-gallery-thumb" },
                        [
                          _c(
                            "swiper",
                            {
                              ref: "swiperThumb",
                              staticClass: "swiper",
                              attrs: { options: _vm.swiper_option_thumb }
                            },
                            _vm._l(_vm.images, function(image, index) {
                              return _c(
                                "swiper-slide",
                                {
                                  key: index,
                                  class: index == _vm.active ? "active" : ""
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "img-gallery-thumb swiper-lazy",
                                    attrs: {
                                      "data-src": image.url.gallery_preview
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.select(index)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "swiper-lazy-preloader"
                                  })
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasIcons
            ? _c("modal", {
                ref: "plan-gallery",
                attrs: {
                  name: "plan-gallery",
                  "extra-class": "full-screen plan-gallery"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function(props) {
                        return [
                          _c("img", {
                            staticClass: "plan-gallery-img",
                            attrs: { src: props.data.url.detail }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4020140901
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasIcons
            ? _c("modal", {
                ref: "plan-virtualtour",
                attrs: {
                  name: "plan-virtualtour",
                  "extra-class": "full-screen plan-gallery"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function(props) {
                        return [
                          _c("iframe", {
                            staticClass: "virtual-tour embed-responsive-item",
                            attrs: {
                              src: props.data.url,
                              bordersize: "0",
                              allowfullscreen: "true",
                              allow: "vr,gyroscope,accelerometer"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2668335991
                )
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }